import { PDFDocument } from 'pdf-lib';

export async function splitPdfToBlobs(arrayBuffer: ArrayBuffer): Promise<Blob[]> {
	const src = await PDFDocument.load(arrayBuffer);
	const total = src.getPageCount();
	const blobs: Blob[] = [];
	for (let i = 0; i < total; i += 1) {
		const dst = await PDFDocument.create();
		const [page] = await dst.copyPages(src, [i]);
		dst.addPage(page);
		const bytes = await dst.save();
		blobs.push(new Blob([bytes], { type: 'application/pdf' }));
	}
	return blobs;
}

export function downloadBlob(blob: Blob, filename: string): void {
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	a.style.display = 'none';
	document.body.appendChild(a);
	a.click();
	setTimeout(() => {
		document.body.removeChild(a);
		URL.revokeObjectURL(url);
	}, 0);
}

export function sanitizeFilename(s: string): string {
	return (s || '')
		.replace(/[\\/:*?"<>|]+/g, ' ')
		.replace(/\s+/g, ' ')
		.trim();
}

// Grava um Blob diretamente em um diretório escolhido pelo usuário (File System Access API)
export async function saveBlobToDirectory(
	dirHandle: any, // FileSystemDirectoryHandle
	filename: string,
	blob: Blob
): Promise<void> {
	// Tenta criar/obter o arquivo e escrever seu conteúdo
	const fileHandle = await dirHandle.getFileHandle(filename, { create: true });
	// @ts-ignore - tipos podem variar conforme suporte do navegador
	const writable: any = await (fileHandle as any).createWritable();
	await writable.write(blob);
	await writable.close();
}

export async function ensureDirectoryWritePermission(dirHandle: any): Promise<boolean> {
	try {
		// @ts-ignore
		if (!dirHandle || !dirHandle.queryPermission || !dirHandle.requestPermission) return false;
		// @ts-ignore
		let perm = await dirHandle.queryPermission({ mode: 'readwrite' });
		if (perm === 'granted') return true;
		// @ts-ignore
		perm = await dirHandle.requestPermission({ mode: 'readwrite' });
		return perm === 'granted';
	} catch {
		return false;
	}
}


